var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpfitPreparation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Upfit_Preparation"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upfit_Preparation",
    "data-name": "Upfit Preparation",
    clipPath: "url(#clip-Upfit_Preparation)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11765",
    "data-name": "Group 11765",
    transform: "translate(2.318 0.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11766",
    "data-name": "Group 11766",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22200",
    "data-name": "Path 22200",
    d: "M1.479,16.378H1.191a.2.2,0,0,0-.164-.039.927.927,0,0,1-.545-.217,1,1,0,0,1-.336-.375A.978.978,0,0,1,0,15.328q0-1.78,0-3.56Q0,6.408,0,1.048A.427.427,0,0,1,.031.869,1.509,1.509,0,0,1,.367.352,1.193,1.193,0,0,1,1.192,0Q6.646,0,12.1,0a1.209,1.209,0,0,1,.953.439,1.257,1.257,0,0,1,.31.838q0,6.935,0,13.87a1.224,1.224,0,0,1-.521.984,1.292,1.292,0,0,1-.895.219,4.94,4.94,0,0,0-.859.026H9.279a1.756,1.756,0,0,0-.375-.015,4.351,4.351,0,0,0-.61.015H8.17a.3.3,0,0,0-.131-.017c-1.371-.042-2.742,0-4.113-.017-.752-.009-1.5.038-2.256.009a.373.373,0,0,0-.191.025M.473,8.182c0,2.322,0,4.644,0,6.967a.783.783,0,0,0,.719.719q5.475-.007,10.95,0a.743.743,0,0,0,.731-.74q0-3.011,0-6.023,0-3.924,0-7.849a.724.724,0,0,0-.212-.522A.849.849,0,0,0,12.02.494H1.378A1.22,1.22,0,0,0,.909.57a.751.751,0,0,0-.436.614q0,3.5,0,7",
    transform: "translate(0 0)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22201",
    "data-name": "Path 22201",
    d: "M54.167,58.217H51.991a.539.539,0,0,0-.339.156.689.689,0,0,0-.234.606q.006.272,0,.544c0,.067.018.086.085.086.315,0,.629,0,.944,0a.675.675,0,0,1,.482.142.615.615,0,0,1,.232.435c.009.386.018.774,0,1.159a.589.589,0,0,1-.4.512.728.728,0,0,1-.288.059c-.862,0-1.724,0-2.586,0a.664.664,0,0,1-.627-.358.609.609,0,0,1-.072-.292c0-.328.006-.657,0-.985a.655.655,0,0,1,.657-.668c.311,0,.623,0,.934,0,.152,0,.151,0,.152-.149,0-.222-.012-.446.008-.666a1.133,1.133,0,0,1,.484-.852,1,1,0,0,1,.347-.185,1.958,1.958,0,0,1,.435-.05c.54,0,1.081,0,1.621,0,.092,0,.116-.024.112-.114-.008-.164-.007-.328,0-.492,0-.079-.02-.1-.1-.1-.424,0-.848,0-1.272,0a.7.7,0,0,1-.69-.684c0-.321,0-.643,0-.964a.685.685,0,0,1,.708-.668q1.611,0,3.222,0a.7.7,0,0,1,.542.246.59.59,0,0,1,.143.393c0,.339.006.677,0,1.016a.663.663,0,0,1-.663.66c-.43.016-.862.007-1.293,0-.1,0-.115.031-.111.116.008.171.013.342.009.513,0,.063.015.076.073.074.133,0,.267,0,.4,0,.428,0,.855,0,1.283,0a1.222,1.222,0,0,1,.814.256,1.129,1.129,0,0,1,.434.853c.008.222.01.445,0,.667,0,.1.034.126.125.126.308,0,.616,0,.924,0a.669.669,0,0,1,.449.13.581.581,0,0,1,.246.445c0,.349,0,.7,0,1.046a.621.621,0,0,1-.414.629.648.648,0,0,1-.258.054H55.871a.676.676,0,0,1-.673-.662c-.006-.332-.007-.664,0-1a.638.638,0,0,1,.392-.6.666.666,0,0,1,.288-.047c.322,0,.643,0,.965,0,.072,0,.1-.01.1-.093-.014-.262.015-.525-.019-.788a.584.584,0,0,0-.269-.41.66.66,0,0,0-.405-.11c-.694.005-1.389,0-2.083,0Zm.014-1.72H55.8c.138,0,.2-.057.2-.185q0-.446,0-.892c0-.2-.037-.238-.238-.238h-3.15c-.191,0-.243.044-.245.246,0,.277,0,.554,0,.831,0,.183.055.239.237.239h1.58m-3.022,4.918c.431,0,.861,0,1.292,0a.2.2,0,0,0,.225-.229c-.011-.3,0-.594,0-.892,0-.152-.041-.2-.19-.2l-2.635,0c-.141,0-.172.03-.173.174q0,.471,0,.943c0,.142.057.194.2.194h1.281M57.2,60.1h-1.3c-.17,0-.185.016-.185.19q0,.456,0,.913c0,.157.048.207.2.207q1.283,0,2.565,0c.165,0,.228-.065.228-.23q0-.431,0-.862c0-.17-.048-.219-.217-.22H57.2",
    transform: "translate(-47.519 -52.841)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22202",
    "data-name": "Path 22202",
    d: "M135.743,315.876q1.7,0,3.405,0a.294.294,0,0,1,.3.184.243.243,0,0,1-.127.292.445.445,0,0,1-.179.031l-3.467,0c-1.043,0-2.085,0-3.128,0a1.111,1.111,0,0,1-.4-.021.238.238,0,0,1-.147-.2.217.217,0,0,1,.086-.206.306.306,0,0,1,.216-.075q1.718,0,3.436,0",
    transform: "translate(-127.541 -305.203)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22205",
    "data-name": "Path 22205",
    d: "M134.056,427.147c.571,0,1.142,0,1.713,0a.245.245,0,0,1,.223.11.263.263,0,0,1-.011.306.234.234,0,0,1-.212.079h-3.385c-.106,0-.207-.007-.267-.125a.246.246,0,0,1,.2-.367h1.734",
    transform: "translate(-127.652 -414.189)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22206",
    "data-name": "Path 22206",
    d: "M49.75,316.363c-.12,0-.239,0-.359,0a.247.247,0,0,1-.232-.389.255.255,0,0,1,.222-.117c.253,0,.506-.006.759,0a.258.258,0,0,1,.223.4c-.051.091-.152.1-.244.1-.123,0-.246,0-.369,0v0",
    transform: "translate(-47.455 -305.185)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22207",
    "data-name": "Path 22207",
    d: "M49.816,427.18c.133,0,.266,0,.4,0,.117,0,.189.064.231.2a.245.245,0,0,1-.1.251.286.286,0,0,1-.164.043c-.256,0-.512,0-.769,0a.231.231,0,0,1-.254-.252.252.252,0,0,1,.263-.238h.389Z",
    transform: "translate(-47.5 -414.246)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpfitPreparation);
export default __webpack_public_path__ + "static/media/Upfit Preparation.4150251a2c042300cf7e577beaca594a.svg";
export { ForwardRef as ReactComponent };